/**
 * conversationStorage.js
 * Utilidad para gestionar la persistencia de conversaciones en localStorage
 */

const ConversationStorage = {
    /**
     * Guarda una conversación en el localStorage
     * @param {string} sessionId - ID único de la sesión
     * @param {Array} answers - Respuestas de la conversación
     * @param {Array} controlAnswers - Estado de control de las respuestas
     * @param {number} totalAnswers - Total de respuestas
     */
    saveConversation: (sessionId, answers, controlAnswers, totalAnswers) => {
      try {
        const conversationData = {
          answers,
          controlAnswers,
          totalAnswers,
          timestamp: Date.now(),
        };
        localStorage.setItem(`conversation_${sessionId}`, JSON.stringify(conversationData));
        
        // Actualizar índice de sesiones
        const sessionIndex = JSON.parse(localStorage.getItem('session_index') || '[]');
        if (!sessionIndex.includes(sessionId)) {
          sessionIndex.push(sessionId);
          localStorage.setItem('session_index', JSON.stringify(sessionIndex));
        }
      } catch (error) {
        console.error('Error al guardar conversación:', error);
      }
    },
  
    /**
     * Carga una conversación desde localStorage
     * @param {string} sessionId - ID de la sesión a cargar
     * @returns {Object|null} - Datos de la conversación o null si no existe
     */
    loadConversation: (sessionId) => {
      try {
        const storedConversation = localStorage.getItem(`conversation_${sessionId}`);
        if (storedConversation) {
          return JSON.parse(storedConversation);
        }
        return null;
      } catch (error) {
        console.error('Error al cargar conversación:', error);
        return null;
      }
    },
  
    /**
     * Obtiene todos los IDs de sesión almacenados
     * @returns {Array} - Lista de IDs de sesión
     */
    getAllSessionIds: () => {
      try {
        return JSON.parse(localStorage.getItem('session_index') || '[]');
      } catch (error) {
        console.error('Error al obtener índice de sesiones:', error);
        return [];
      }
    },
  
    /**
     * Elimina una conversación almacenada
     * @param {string} sessionId - ID de la sesión a eliminar
     * @returns {boolean} - True si se eliminó correctamente
     */
    deleteConversation: (sessionId) => {
      try {
        localStorage.removeItem(`conversation_${sessionId}`);
        
        // Actualizar índice de sesiones
        const sessionIndex = JSON.parse(localStorage.getItem('session_index') || '[]');
        const updatedIndex = sessionIndex.filter(id => id !== sessionId);
        localStorage.setItem('session_index', JSON.stringify(updatedIndex));
        
        return true;
      } catch (error) {
        console.error('Error al eliminar conversación:', error);
        return false;
      }
    },
  
    /**
     * Obtiene metadatos de todas las sesiones almacenadas
     * @returns {Array} - Lista de objetos con información de sesión
     */
    getSessionsMetadata: () => {
      try {
        return ConversationStorage.getAllSessionIds().map(id => {
          const session = ConversationStorage.loadConversation(id);
          return {
            id,
            timestamp: session?.timestamp || 0,
            firstMessage: session?.answers?.[1]?.text?.substring(0, 50) || 'Nueva conversación',
            messageCount: session?.answers?.length || 0
          };
        }).sort((a, b) => b.timestamp - a.timestamp); // Ordenar por más reciente
      } catch (error) {
        console.error('Error al obtener metadatos de sesiones:', error);
        return [];
      }
    }
  };
  
  export default ConversationStorage;